<template>
  <div class="point-manege">
    <div class="title-box">监控点位标识管理</div>
    <!-- 查询条件 -->
    <div class="header-box">
      <el-form
        id="formID"
        :inline="true"
        :model="queryParams"
        style="border-radius: 3px; margin-bottom: 10px; box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.1)"
        class="demo-form-inline"
      >
        <el-form-item label="选择工厂">
          <el-select v-model="queryParams.factoryValue" filterable placeholder="选择工厂" @change="factoryChange">
            <el-option v-for="item in factoryOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择车间">
          <el-select v-model="queryParams.workshopValue" filterable placeholder="选择车间">
            <el-option v-for="item in workshopOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="pont-content">
      <div class="point-body">
        <div class="graph-box">
          <div class="point-type">
            <div class="lable">
              <span class="lable-inner"> 添加点位类型 </span>
              <span>（拖拽至点位示意图）</span>
            </div>
            <!-- 边缘机 -->
            <div ref="dndContainerRef" class="graphics">
              <template v-for="device in bizDevices">
                <div :key="`index${device.dictValue}`" class="dnd-rect" @mousedown="startDrag($event, device)">
                  <img v-if="device.dictValue === '1'" src="@/assets/images/point-camera.svg" />
                  <img v-if="device.dictValue === '2'" src="@/assets/images/point-pressure.svg" />
                  <img v-if="device.dictValue === '3'" src="@/assets/images/point-air-particles.svg" />
                  <img v-if="device.dictValue === '4'" src="@/assets/images/ponit-ozone-concentration.svg" />
                  <img v-if="device.dictValue === '5'" src="@/assets/images/point-Temperature.svg" />
                  <img v-if="device.dictValue === '7'" src="@/assets/images/calculate-box.svg" />
                </div>
              </template>
              <!-- <div data-type="camera" class="dnd-rect" @mousedown="startDrag">
                  <img src="@/assets/images/point-camera.svg" />
                </div> -->
              <!-- 温湿度传感器 -->
              <!-- <div data-type="temperature" class="img" @mousedown="startDrag">
                  <img src="@/assets/images/point-Temperature.svg" />
                </div> -->
              <!-- 气压变送器 -->
              <!-- <div data-type="airPressure" class="img" @mousedown="startDrag">
                  <img src="@/assets/images/point-pressure.svg" />
                </div> -->
              <!-- 空气粒子计数器 -->
              <!-- <div data-type="airParticles" class="img" @mousedown="startDrag">
                  <img src="@/assets/images/point-air-particles.svg" />
                </div> -->
              <!-- 空气粒子计数器 -->
              <!-- <div data-type="ozoneConcentration" class="img" @mousedown="startDrag">
                  <img src="@/assets/images/ponit-ozone-concentration.svg" />
                </div> -->
            </div>
          </div>
          <div class="graph-container" ref="graphRef"></div>
        </div>
        <!-- 
        <span role="presentation" class="Resizer vertical" @mousedown.prevent="startResize"></span> -->

        <div class="graph-operation">
          <div class="operation-box">
            <div class="device-relations" ref="deviceRelationsRef">
              <el-table
                :data="scencePointList"
                border
                :style="{ height: tableHeight + 'px', width: '100%', 'border-radius': '3px' }"
                :height="tableHeight"
                class="custom-table-header"
                v-loading="loading"
              >
                <el-table-column prop="index" label="序号" width="80" align="center" type="index"></el-table-column>
                <el-table-column prop="factoryName" label="工厂" align="center"></el-table-column>
                <el-table-column prop="workshopName" label="车间" align="center"></el-table-column>
                <el-table-column prop="sceneName" label="场景" align="center"></el-table-column>
                <el-table-column prop="id" label="监测点编号" width="120" align="center"></el-table-column>
                <el-table-column prop="pointTypeName" label="监测点类型" width="120" align="center"></el-table-column>
                <el-table-column prop="deviceNum" label="IoT硬件编号" width="120" align="center"></el-table-column>
                <el-table-column prop="status" label="点位设备关联" width="100" align="center">
                  <template #default="{ row }">
                    <el-tag :type="row.deviceId ? 'success' : 'danger'">
                      {{ row.deviceId ? '已绑定' : '未绑定' }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="操作" class-name="operation" width="100" align="center" fixed="right">
                  <template #default="{ row }">
                    <el-button size="small" @click="deletePoint(row)" type="text" class="delete-text">删除</el-button>
                    <el-button size="small" @click="toggleBind(row)" type="text">
                      {{ row.deviceId ? '解绑' : '绑定' }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>

              <!-- 分页 -->
              <div v-if="scenePointTotal" class="block" style="background: #fff; text-align: center; padding: 20px 0">
                <el-pagination
                  @size-change="scenePointSizeChange"
                  @current-change="scenePointCurrentChange"
                  :current-page="scenePointPageConfig.pageIndex"
                  :page-size="scenePointPageConfig.pageSize"
                  :page-sizes="[20, 50, 100, 200]"
                  background
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="scenePointTotal"
                >
                </el-pagination>
              </div>
            </div>
          </div>

          <!-- 固定在底部的操作栏 -->

          <el-button type="primary" size="large" @click="toSave">保存</el-button>
        </div>
      </div>
    </div>

    <!--绑定设备 -->
    <el-dialog title="绑定设备" :visible.sync="dialogFormVisible" width="800px" class="bind-device" center>
      <el-form
        id="formID"
        :inline="true"
        :model="queryParams"
        style="border-radius: 3px; margin-bottom: 10px; box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.1)"
        class="demo-form-inline"
      >
        <el-form-item label="设备名称">
          <el-input v-model="deviceParams.deviceName" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="设备编号">
          <el-input v-model="deviceParams.deviceNum"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="querryDevices">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="resetDevice">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table
        ref="deviceTable"
        :data="deviceList"
        border
        :style="{ 'max-height': tableHeight + 'px', width: '100%', 'border-radius': '3px' }"
        class="custom-table-header"
        @selection-change="selectionChange"
      >
        <el-table-column
          type="selection"
          :selectable="(row) => row.deviceState === 0"
          width="80"
          align="center"
        ></el-table-column>
        <el-table-column prop="index" label="序号" width="80" align="center" type="index"></el-table-column>
        <el-table-column prop="deviceName" label="设备名称" align="center"></el-table-column>
        <el-table-column prop="deviceNum" label="设备编号" align="center"></el-table-column>
        <el-table-column prop="deviceStateName" label="设备状态" width="130" align="center">
          <template #default="{ row }">
            <el-tag :type="row.deviceState ? 'success' : 'danger'">
              {{ row.deviceStateName }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" style="color: #000 !important">取 消</el-button>
        <el-button type="primary" @click="addPonintConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Path, Graph } from '@antv/x6';
import { Dnd } from '@antv/x6-plugin-dnd'; // 拖拽插件
import { Selection } from '@antv/x6-plugin-selection'; // 选择插件

import request from '@/utils/request';
import api from '@/utils/api';

import { Message, MessageBox } from 'element-ui';

export default {
  data() {
    return {
      queryParams: {
        factoryValue: '',
        workshopValue: ''
      },
      cloneNewNode: {},
      sceneJson: {},
      graph: null,
      dnd: null,
      tableHeight: 509,
      dialogFormVisible: false,
      isResizing: false,
      startX: 0,
      startWidth: 0,
      //工厂类型
      factoryOptions: [],
      workshopOptions: [],
      curCell: null,
      deviceList: [],
      scencePointList: [],
      tableData: [],
      lastMousePosition: { x: 0, y: 0 }, // 新增：记录鼠标位置
      selectionDevice: [],
      deviceParams: {
        deviceName: '',
        deviceNum: ''
      },
      pointSceneId: '', // 选择的需要绑定设备的场景id
      bizDevices: [],
      scenePointTotal: 0, // 场景点位列表总数
      scenePointPageConfig: {
        pageIndex: 1,
        pageSize: 20
      },
      loading: false,
      pointId: '',
      mayDeleteCell: null
    };
  },
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    setTableHeight() {
      if (this.$refs.deviceRelationsRef) {
        if (this.scenePointTotal) {
          this.tableHeight = this.$refs.deviceRelationsRef.clientHeight - 72;
        } else {
          this.tableHeight = this.$refs.deviceRelationsRef.clientHeight;
        }
      } else {
        this.tableHeight = 509;
      }
    },
    handleKeyDown(e) {
      // 检查是否是Delete键，且当前有选中节点
      if (e.key === 'Delete' && this.mayDeleteCell) {
        // 删除节点
        this.graph.removeCell(this.mayDeleteCell);
        // 清空当前节点引用
        this.mayDeleteCell = null;
      }
    },
    scenePointSizeChange(val) {
      scenePointPageConfig.pageSize = val;
      scenePointPageConfig.pageIndex = 1;
      this.getScenePoint();
    },
    scenePointCurrentChange(val) {
      scenePointPageConfig.pageIndex = val;
      this.getScenePoint();
    },
    // 获取场景类型
    getBizSceneType() {
      request
        .get(`${api.pointManagement.getBizDeviceName}`)
        .then((res) => {
          if (res.code === 200) {
            this.bizDevices = res.data;
          } else {
            this.bizDevices = [];
          }
        })
        .catch((err) => {
          this.bizDevices = [];
        });
    },
    // 工厂变更
    factoryChange() {
      this.queryParams.workshopValue = '';
      this.getWorkShopList();
    },
    // 删除点位
    deletePoint(row) {
      MessageBox.confirm('是否确认删除' + row.pointTypeName + '(' + row.id + ')' + '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          request
            .delete(`${api.pointManagement.delScenePoint}/${row.id}`)
            .then((res) => {
              if (res.code === 200) {
                this.$message.success('删除成功');
                this.getScenePoint();
                this.getSceneLayout();
              } else {
                this.$message.error('删除失败');
              }
            })
            .catch((err) => {
              this.$message.error('删除失败');
            });
        })
        .catch(() => {});
    },
    resetDevice() {
      this.deviceParams = {
        deviceName: '',
        deviceNum: ''
      };

      this.getSceneDeviceList();
    },
    // 根据条件查询设备
    querryDevices() {
      this.getSceneDeviceList();
    },
    // 选择设备变化的时候触发
    selectionChange(devices) {
      this.selectionDevice = devices;
    },
    // 确定绑定设备
    addPonintConfirm() {
      if (!this.deviceList.length) {
        return this.$message.warning('无设备，请安装设备后再绑定');
      }
      const params = {
        sceneId: this.pointSceneId,
        remark: '',
        pointListBo: this.selectionDevice.map((item) => {
          return {
            id: this.pointId,
            deviceName: item.deviceName,
            deviceId: item.deviceId,
            deviceNum: item.deviceNum,
            installDetailId: item.installDetailId
          };
        })
      };
      request
        .post(`${api.pointManagement.savePointDevice}`, params)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('绑定成功');
            this.dialogFormVisible = false;
            // 刷新页面
            this.getScenePoint();
            this.getSceneLayout();
          } else {
            this.$message.error('绑定失败');
          }
        })
        .catch((err) => {
          this.$message.error('绑定失败');
        });
    },
    onReset() {
      this.queryParams = {
        factoryValue: '',
        workshopValue: ''
      };
    },
    onSubmit() {
      this.getSceneLayout();
    },
    // 保存节点
    toSave() {
      this.graph.cleanSelection();
      this.curCell = null;
      const json = this.graph.toJSON();
      // 获取是所有节点
      const nodes = this.graph.getNodes();
      // 找出父节点
      const parentNodes = nodes.filter((node) => node.getData().isParent) || [];

      let workshopSceneLayoutData = [];
      if (parentNodes.length) {
        // 场景节点
        workshopSceneLayoutData = parentNodes.map((parent) => {
          // 设备节点
          let children = [];
          children = (parent.getChildren() || []).map((device) => {
            const pointNodeData = device.getData();
            return {
              pointId: pointNodeData.pointId ? pointNodeData.pointId : 0,
              // id 改成 pointId
              // deviceId: 0,
              // deviceName: 'camer',
              // deviceNum: '',
              cellId: pointNodeData.pointId ? pointNodeData.cellId : device.id,
              pointType: device.data.deviceInfo.dictValue
            };
          });
          return {
            sceneId: parent.data.sceneId,
            sceneName: parent.data.sceneName,
            sceneType: parent.data.sceneType,
            cellId: parent.data.cellId,
            scenePointInfoList: children
          };
        });
      }

      const params = {
        workshopId: this.queryParams.workshopValue,
        workshopSceneLayoutJsonStr: JSON.stringify(json),
        workshopSceneLayoutData
      };

      request
        .post(`${api.pointManagement.workshopScene}`, params)
        .then((res) => {
          if (res.code === 200) {
            this.getScenePoint();
            this.getSceneLayout();
          }
        })
        .catch((err) => {});
    },
    handleEdit(row) {
      console.log('修改操作', row);
      // 这里可以打开编辑对话框
    },
    toggleBind(row) {
      this.pointSceneId = row.sceneId;
      this.pointId = row.id;
      this.deviceParams.deviceName = row.pointTypeName;
      if (row.deviceId) {
        // 解除绑定逻辑
        this.unBindDeviceFn();
      } else {
        this.dialogFormVisible = true;
        this.getSceneDeviceList();
      }
    },
    unBindDeviceFn() {
      request
        .post(`${api.pointManagement.unBindDevice}?id=${this.pointId}`, {
          // 这是 GET 请求的标准传参方式
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success(res.msg);
            this.getScenePoint();
            this.getSceneLayout();
          }
        });
    },
    // 初始化画布
    initGraph() {
      this.graph = new Graph({
        container: this.$refs.graphRef,
        panning: {
          // 禁用画布拖拽
          enabled: true // 关闭画布平移
        },
        interacting: {
          // 控制交互行为
          nodeMovable: (cellView) => {
            // 父节点不可移动，子节点可移动
            return !cellView.cell.data || !cellView.cell.data.isParent;
          }
        },
        translating: {
          // 子节点只能在父节点内移动
          restrict(view) {
            const cell = view.cell;
            if (cell.isNode()) {
              const parent = cell.getParent();
              if (parent) {
                return parent.getBBox();
              }
            }

            return null;
          }
        },
        mousewheel: {
          enabled: true, // 启用滚轮缩放
          zoomAtMousePosition: true, // 以鼠标位置为中心缩放
          modifiers: [], // 无需按修饰键（默认需要按ctrl）
          minScale: 0.5, // 最小缩放比例
          maxScale: 3, // 最大缩放比例
          zoomFactor: 0.1 // 缩放速度
        },
        background: {
          color: '#F2F7FA'
        },
        grid: {
          visible: true,
          type: 'doubleMesh',
          args: [
            {
              color: '#eee', // 主网格线颜色
              thickness: 1 // 主网格线宽度
            },
            {
              color: '#ddd', // 次网格线颜色
              thickness: 1, // 次网格线宽度
              factor: 4 // 主次网格线间隔
            }
          ]
        }
      });

      this.dnd = new Dnd({
        target: this.graph,
        scaled: false,
        dndContainer: this.$refs.dndContainerRef,
        getDragNode: (node) =>
          node.clone({
            ...this.newNode,
            keepId: true
          }),
        getDropNode: this.dropFn,
        validateNode: this.validateFn
      });

      this.graph.use(
        new Selection({
          enabled: true, // 开启选择功能
          rubberband: false, // 启用框选
          multiple: false, // 允许多选（按住 Ctrl/Cmd）
          movable: (cellView) => {
            // 父节点不可移动，子节点可移动
            const cell = cellView.cell;

            return cell.isNode() && cell.getParent();
          }, // 选中节点可拖动
          strict: false, // 框选时部分重叠即选中（true 需完全包含）
          showNodeSelectionBox: false, // 显示节点选中框
          className: 'my-selecting',
          pointerEvents: 'none' // 避免遮挡事件:cite[7]:cite[10]
        })
      );

      // this.graph.on('cell:click', this.cellFn);

      this.graph.on('node:selected', ({ node }) => {
        // 设置选中样式

        if (node.isNode() && node.getData().isParent) {
          // 父节点选中
          node.attr('body/fill', '#CEE2FF');

          node.attr('body/stroke', '#CEE2FF');
          this.curCell = node;
        }

        if (node.isNode() && node.getParent()) {
          // 子节点
          const data = node.getData();
          if (!data.pointId && !data.deviceId) {
            node.attr('body/fill', '#FFD700');
            node.attr('body/stroke', '#FFA500');
            this.mayDeleteCell = node;
          }
        }
      });

      this.graph.on('node:unselected', ({ node }) => {
        // 从节点数据获取原始样式
        if (node.isNode() && node.getData().isParent) {
          this.curCell = null;
          const originalStyle = node.getData()?.originalStyle;
          if (originalStyle) {
            node.attr('body/fill', originalStyle.fill);
            node.attr('body/stroke', originalStyle.stroke);
          } else {
            // 默认恢复样式
            node.attr('body/fill', '#FFFFFF');
            node.attr('body/stroke', '#595959');
          }
        }

        if (node.isNode() && node.getParent()) {
          // 子节点
          const data = node.getData();
          if (!data.pointId && !data.deviceId) {
            node.attr('body/fill', '#c1c1c1');
            node.attr('body/stroke', '#c1c1c1');
            this.mayDeleteCell = null;
          }
        }
      });

      this.graph.on('blank:click', () => {
        // 清空选中
        // this.graph.cleanSelection();
        // 清空当前节点引用

        this.curCell = null;
      });

      window.addEventListener('keydown', this.handleKeyDown);
    },
    // 是否是点位节点
    isPointInNode(point, node) {
      const bbox = node.getBBox();
      return (
        point.x >= bbox.x && point.x <= bbox.x + bbox.width && point.y >= bbox.y && point.y <= bbox.y + bbox.height
      );
    },
    // 拖拽放置校验
    validateFn(node) {
      const point = this.graph.clientToLocal(this.lastMousePosition.x, this.lastMousePosition.y);

      const isInSelectedNode = this.isPointInNode(point, this.curCell);

      // 验证放置目标 如果放置目标不是父节点 或者放置目标不是当前选中的父节点
      if (!isInSelectedNode || !this.curCell.data.isParent) {
        this.cloneNewNode = '';
        this.$message.warning('只能放置到当前选中的节点上');
        document.removeEventListener('mousemove', this.handleGlobalMouseMove);
        return false; // 返回null阻止放置
      }

      this.setRelationShip();
      document.removeEventListener('mousemove', this.handleGlobalMouseMove);
      return true;
    },
    // 放置节点
    dropFn(node) {
      const cloneNode = node.clone({
        ...this.newNode,
        keepId: true
      });
      this.cloneNewNode = cloneNode;

      return cloneNode;
    },
    // 设置父子关系
    setRelationShip() {
      if (this.curCell) {
        this.cloneNewNode.setParent(this.curCell);
        let childrenCells = [this.cloneNewNode];

        if (this.curCell.getChildren()) {
          childrenCells = [...this.curCell.getChildren(), this.cloneNewNode];
        }

        this.curCell.setChildren(childrenCells);
      }
    },
    // 选中节点
    cellFn({ cell }) {
      this.curCell = cell;
    },
    startResize(e) {
      this.isResizing = true;
      this.startX = e.clientX;
      this.startWidth = this.$refs.graphRef.offsetWidth;

      document.addEventListener('mousemove', this.handleMouseMove);
      document.addEventListener('mouseup', this.stopResize);
      document.body.style.cursor = 'col-resize';
      document.body.style.userSelect = 'none';
    },
    handleMouseMove(e) {
      if (!this.isResizing) return;

      const dx = e.clientX - this.startX;
      const newWidth = this.startWidth + dx;

      // 设置最小和最大宽度限制
      const minWidth = 0;
      const maxWidth = 1300;

      this.$refs.graphRef.style.width = Math.max(minWidth, Math.min(maxWidth, newWidth)) + 'px';
    },
    stopResize() {
      this.isResizing = false;
      document.removeEventListener('mousemove', this.handleMouseMove);
      document.removeEventListener('mouseup', this.stopResize);
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
      this.graph.centerContent(); // 居中显示
    },
    startDrag(e, device) {
      if (!this.curCell) {
        return this.$message.warning('请先选择场景');
      }
      // const target = e.currentTarget;
      // const type = target.getAttribute('data-type');
      let node = '';

      const commonconfig = {
        shape: 'path',
        x: 40,
        y: 40,
        width: 30,
        height: 30,
        zIndex: 2,
        data: {
          originSize: { width: 30, height: 30 },
          originalStyle: {
            // fill: '#8f8f8f',
            // stroke: '#8f8f8f',
            // strokeWidth: 1
            fill: '#c1c1c1',
            stroke: '#c1c1c1',
            strokeWidth: 1
          },
          deviceInfo: device
        },
        label: '',
        // 使用 path 属性指定路径的 pathData，相当于指定路径的 refD 属性
        attrs: {
          body: {
            fill: '#c1c1c1',
            stroke: '#c1c1c1',
            strokeWidth: 1
          }
        }
      };

      node = this.graph.createNode({
        ...commonconfig,
        // 使用 path 属性指定路径的 pathData，相当于指定路径的 refD 属性
        path: device.cssClass
      });

      this.newNode = node;
      document.addEventListener('mousemove', this.handleGlobalMouseMove);
      this.dnd.start(node, e);
    },
    handleDropEvent(x, y) {
      const cell = this.graph.getCellAt(x, y);
      if (cell && cell === this.curCell) {
        const node = this.dnd.draggingNode.clone();

        // 设置节点相对于父节点的位置
        const parentPos = cell.position();
        node.position(x - parentPos.x, y - parentPos.y);

        // 先将节点添加到画布
        this.graph.addNode(node);

        // 然后建立父子关系
        cell.addChild(node);
      } else {
        this.$message.warning('只能拖放到当前选中的节点上');
      }
    },
    // 查询工厂
    getFactoryList() {
      request
        .get(`${api.dropdownList.factoryList}`, {
          params: {
            tenantId: '00'
          }
        })
        .then((res) => {
          if (res.code === 200 && res?.data?.length) {
            this.factoryOptions = (res.data || []).map((item) => {
              return {
                label: item.name,
                value: item.id
              };
            });

            if (this.factoryOptions.length) {
              this.queryParams.factoryValue = this.factoryOptions[0].value;
              this.getWorkShopList();
            }
          } else {
            this.factoryOptions = [];
          }
        })
        .catch((err) => {
          this.factoryOptions = [];
        });
    },
    // 查询车间
    getWorkShopList() {
      request
        .get(`${api.dropdownList.workshopList}`, {
          params: {
            // 这是 GET 请求的标准传参方式
            factoryId: this.queryParams.factoryValue
          }
        })
        .then((res) => {
          if (res.code === 200 && res?.data?.length) {
            this.workshopOptions = (res.data || []).map((item) => {
              return {
                label: item.name,
                value: item.id
              };
            });
            if (this.workshopOptions.length) {
              this.queryParams.workshopValue = this.workshopOptions[0].value;
              this.getSceneLayout();
            }
          } else {
            this.workshopOptions = [];
          }
        })
        .catch((err) => {
          this.workshopOptions = [];
        });
    },
    // 查询场景设备
    getSceneDeviceList(row) {
      this.deviceList = [];
      request
        .post(`${api.pointManagement.getSceneEquipInfoBySceneId}`, {
          // 这是 GET 请求的标准传参方式
          sceneId: this.pointSceneId,
          deviceName: this.deviceParams.deviceName,
          deviceNum: this.deviceParams.deviceNum
        })
        .then((res) => {
          if (res.code === 200 && res?.data?.length) {
            this.deviceList = res.data || [];
          } else {
            this.deviceList = [];
          }
        })
        .catch((err) => {
          this.deviceList = [];
        });
    },
    // 获取场景图
    getSceneLayout() {
      console.log(`${api.pointManagement.getWorkShopLayout}/${this.queryParams.workshopValue}`);
      request
        .get(`${api.pointManagement.getWorkShopLayout}/${this.queryParams.workshopValue}`)
        .then((res) => {
          if (res.code === 200) {
            const { workshopSceneLayoutData, workshopSceneLayoutJsonStr } = res.data;
            if (workshopSceneLayoutJsonStr && workshopSceneLayoutData) {
              this.sceneJson = JSON.parse(workshopSceneLayoutJsonStr);
              const cells = this.sceneJson.cells;

              if (this.graph && cells.length) {
                // 创建有效ID集合（包含场景ID和点位ID）
                const validCellIds = new Set();
                // 收集所有有效ID
                workshopSceneLayoutData.forEach((scene) => {
                  // 添加场景单元格ID
                  validCellIds.add(scene.cellId);
                  // 添加点位单元格ID
                  scene.scenePointInfoList.forEach((point) => {
                    validCellIds.add(point.cellId);
                  });
                });

                // 反向遍历并删除无效单元格（避免索引错位）
                for (let i = cells.length - 1; i >= 0; i--) {
                  if (!validCellIds.has(cells[i].id)) {
                    cells.splice(i, 1);
                  }
                }
                // 处理点位数据
                workshopSceneLayoutData.forEach((scene) => {
                  const foundSceneCell = cells.find((cell) => cell.id === scene.cellId);

                  if (foundSceneCell) {
                    foundSceneCell.data = {
                      ...foundSceneCell.data,
                      ...scene
                    };
                  }
                  scene.scenePointInfoList.forEach((point) => {
                    const pointCell = cells.find((cell) => cell.id === point.cellId);
                    if (pointCell) {
                      pointCell.data = {
                        ...pointCell.data,
                        pointId: point.pointId,
                        deviceId: point.deviceId,
                        cellId: point.cellId
                      };
                    }
                  });
                });
              }

              this.graph.fromJSON(this.sceneJson); // 渲染元素
              const nodes = this.graph.getNodes();
              // 更新节点样式
              this.updataNodesStyle(nodes);
              this.graph.centerContent(); // 居中显示
              // 获取场景点位
              this.getScenePoint();
            } else {
              this.sceneJson = {};
              this.graph.fromJSON(this.sceneJson); // 渲染元素
            }
          }
        })
        .catch((err) => {
          this.sceneJson = {};
          this.graph.fromJSON(this.sceneJson);
        });
    },
    // 获取场景点位
    getScenePoint() {
      this.loading = true;
      const params = {
        factoryId: this.queryParams.factoryValue,
        workshopId: this.queryParams.workshopValue,
        pageSize: this.scenePointPageConfig.pageSize,
        pageNum: this.scenePointPageConfig.pageIndex,
        orderByColumn: '',
        isAsc: '',
        firstNum: 1
      };

      request
        .get(`${api.pointManagement.getScenePointList}`, {
          params: params
        })
        .then((res) => {
          if (res.code === 200) {
            this.scencePointList = res.rows;
            this.scenePointTotal = res.total;
          } else {
            this.scencePointList = [];
            this.scenePointTotal = 0;
          }
        })
        .catch((err) => {
          this.scencePointList = [];
          this.scenePointTotal = 0;
        })
        .finally(() => {
          this.setTableHeight();
          this.loading = false;
        });
    },
    // 更新节点样式
    updataNodesStyle(nodes) {
      let noDeviceColor = '#8f8f8f'; // 没有设备的颜色
      let deviceColor = '#7719aa'; // 绑定设备的颜色

      nodes.forEach((node) => {
        // 3. 检查是否为节点（现在使用正确的图形对象）
        if (node.isNode()) {
          // 节点如果是子节点，有id且没有设备id则只是保存 没有绑定设备。颜色是noDeviceColor: '#8f8f8f',
          // 节点如果是子节点，有id且有设备id则已经绑定设备deviceColor: '#1ecb80'
          if (node.isNode() && node.getParent()) {
            const data = node.getData();
            if (data.pointId && !data.deviceId) {
              node.attr('body/fill', noDeviceColor);
              node.attr('body/stroke', noDeviceColor);
            }

            if (data.pointId && data.deviceId) {
              node.attr('body/fill', deviceColor);
              node.attr('body/stroke', deviceColor);
            }
          }
        }
      });
    },
    handleGlobalMouseMove(e) {
      this.lastMousePosition = { x: e.clientX, y: e.clientY };
    }
  },
  mounted() {
    this.getBizSceneType();
    this.initGraph();

    this.getFactoryList();

    this.setTableHeight();
  }
};
</script>

<style lang="scss" scoped>
.point-manege {
  .title-box {
    width: 100%;
    font-size: 16px;
    font-weight: bold;
    padding: 27px 0 15px;
    line-height: 16px;
  }

  .header-box {
    :deep(.el-form) {
      .el-form-item {
        .el-form-item__label {
          color: #000;
        }
        margin-bottom: 0;
      }
    }
  }
}

.pont-content {
  position: relative;

  // 固定在底部的操作栏
  .footer-actions {
    width: 100%;
    position: absolute;
    bottom: 45px;
    right: 0;
    background: #fff;
    padding: 20px;
    border-top: 1px solid #ebeef5;
    display: flex;
    gap: 12px;
    justify-content: flex-end;
    z-index: 1000;
    box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.05);
    .el-button--large {
      width: 150px;
    }
  }
}

.point-body {
  display: flex;
  height: calc(100vh - 188px);
  width: 100%;
  .graph-box {
    height: 100%;
    width: 56%;
    overflow-y: auto;
    background: #fff;
    box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    position: relative;

    .point-type {
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      justify-content: flex-start;
      z-index: 1;

      padding: 10px;
      background-color: #fff;

      .lable {
        font-size: 14px;
        font-weight: bold;
        color: #1c1c1c;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }

      .graphics {
        display: flex;
        justify-content: space-around;
        margin-left: 20px;
        img {
          width: 26px;
          height: 30px;

          margin-right: 20px;
          cursor: move;
        }

        &:not(:last-child) {
          margin-right: 10px;
        }
      }
    }
  }

  .operation-box {
    height: calc(100% - 32px);
    background: #fff;
    box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.1);
    border-radius: 2px;
  }

  .graph-container {
    min-width: 400px;
    min-height: 300px;
    width: calc(100% - 23px);
    height: calc(100% - 23px);
    margin: 10px;
    flex-shrink: 0; /* 防止容器被压缩 */
    transition: width 0.2s ease; /* 添加平滑过渡效果 */
  }

  .graph-operation {
    width: 44%;
    margin-left: 10px;
    position: relative; /* 确保分割线定位正确 */

    .device-relations {
      height: 100%;
    }
  }

  .Resizer.vertical {
    width: 11px;
    margin: 0px -5px;
    border-right: 5px solid #ccc;
    border-left: 5px solid #ccc;
    cursor: col-resize;
    transition: all 0.3s;
    &:hover {
      border-color: rgb(0, 0, 0);
    }
  }

  .Resizer {
    z-index: 1;
    box-sizing: border-box;
    opacity: 0.1;
    background: rgb(0, 0, 0);
  }
}

// 表头背景色
::v-deep .custom-table-header th {
  background-color: #ebeef5 !important;
}

::v-deep .el-table td.el-table__cell.operation {
  border-left: 1px solid #ebeef5;
}

// 表格字体大小
.el-table {
  font-size: 12px;
}
// 表单底部边界线
.el-table::before {
  height: 0px;
}
// 表格字体
::v-deep .el-table thead {
  color: #606266;
}
// 表格内边距
::v-deep .el-table .el-table__cell {
  padding: 8px 0;

  .el-button.el-button--text.delete-text {
    color: #606266;
  }
}

:deep(.el-tag) {
  height: 24px;
  line-height: 24px;
}
</style>
<style lang="scss"></style>
